const indexItems = [
  {
    title: '韩漫精选',
    desc: '浪漫宫廷与都市悬疑',
    icon: 'ri-heart-pulse-line',
    img: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20with%20romantic%20palace%20setting%2C%20soft%20warm%20lighting%2C%20elegant%20characters%20in%20traditional%20and%20modern%20fusion%20outfits%2C%20cream%20background%20with%20subtle%20gradient%2C%20editorial%20composition%2C%20clean%20aesthetic&width=600&height=400&seq=index-kr-01&orientation=landscape',
  },
  {
    title: '日漫经典',
    desc: '热血冒险与校园青春',
    icon: 'ri-sword-line',
    img: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20illustration%20with%20school%20life%20and%20adventure%20themes%2C%20vibrant%20warm%20colors%2C%20dynamic%20action%20lines%2C%20youthful%20characters%2C%20cream%20background%20with%20soft%20gradient%2C%20clean%20composition&width=600&height=400&seq=index-jp-02&orientation=landscape',
  },
  {
    title: '国漫崛起',
    desc: '玄幻仙侠与国风美学',
    icon: 'ri-magic-line',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20illustration%20with%20fantasy%20martial%20arts%20and%20mythological%20elements%2C%20traditional%20Chinese%20aesthetics%20with%20flowing%20ink%20wash%20style%2C%20warm%20earth%20tones%2C%20cream%20background%2C%20elegant%20composition&width=600&height=400&seq=index-cn-03&orientation=landscape',
  },
  {
    title: '全本完结',
    desc: '一口气看到大结局',
    icon: 'ri-check-double-line',
    img: 'https://readdy.ai/api/search-image?query=Stack%20of%20colorful%20comic%20books%20and%20manga%20volumes%20arranged%20artistically%2C%20warm%20lighting%2C%20cozy%20reading%20atmosphere%2C%20cream%20background%2C%20clean%20editorial%20style%2C%20soft%20shadows&width=600&height=400&seq=index-complete-04&orientation=landscape',
  },
  {
    title: '每日更新',
    desc: '热门连载实时追更',
    icon: 'ri-timer-flash-line',
    img: 'https://readdy.ai/api/search-image?query=Digital%20comic%20reading%20on%20tablet%20device%20showing%20manga%20panels%2C%20warm%20ambient%20lighting%2C%20modern%20minimal%20setting%2C%20cream%20background%2C%20clean%20editorial%20photography%20style%2C%20soft%20atmosphere&width=600&height=400&seq=index-daily-05&orientation=landscape',
  },
  {
    title: '下拉阅读',
    desc: '丝滑流畅沉浸式体验',
    icon: 'ri-scroll-to-bottom-line',
    img: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20vertical%20scrolling%20webtoon%20style%20comic%20with%20colorful%20panels%2C%20warm%20lighting%2C%20modern%20setting%2C%20cream%20background%2C%20clean%20editorial%20product%20photography&width=600&height=400&seq=index-scroll-06&orientation=landscape',
  },
  {
    title: '免费畅读',
    desc: '零门槛零付费全开放',
    icon: 'ri-vip-crown-line',
    img: 'https://readdy.ai/api/search-image?query=Open%20comic%20book%20with%20colorful%20panels%20spreading%20outward%20like%20butterfly%20wings%2C%20warm%20golden%20lighting%2C%20creative%20freedom%20concept%2C%20cream%20background%2C%20clean%20editorial%20composition&width=600&height=400&seq=index-free-07&orientation=landscape',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-950 mb-3">
              热门专题合集
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              精心整理的漫画专题分类，帮你快速找到想看的类型，不错过任何精彩内容
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3 md:gap-4">
            {indexItems.map((item, i) => (
              <a
                key={i}
                href="#index"
                className="group block bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-300 transition-all cursor-pointer"
              >
                <div className="aspect-[3/2] overflow-hidden bg-background-100">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="p-3 md:p-4">
                  <div className="flex items-center gap-1.5 mb-1.5">
                    <div className="w-5 h-5 flex items-center justify-center text-primary-500">
                      <i className={`${item.icon} text-sm`}></i>
                    </div>
                    <h3 className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{item.title}</h3>
                  </div>
                  <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}